import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PulseScraperAPI } from "components/Apis/Pulse";
import { getWeek } from "components/Pulse/helpers";

export const getWeekDates = createAsyncThunk(
    'pulse/getWeekDates',
    async ({ year, week }, { rejectWithValue }) => {
        try {
            const response = await PulseScraperAPI.getWeekDatesFromYearAndWeek(year, week);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const pulseNavigationSlice = createSlice({
    name: 'pulse',
    initialState: {
        selectedWeek: getWeek(-1),
        selectedYear: new Date().getFullYear(),
        currentTab: "pulse",
        loading: false,
        error: null,
    },
    reducers: {
        setTab: (state, action) => {
            state.currentTab = action.payload;
        },
        setSelectedWeek: (state, action) => {
            state.selectedWeek = action.payload;
        },
        setSelectedYear: (state, action) => {
            state.selectedYear = action.payload;
        }
    },
});

export const { setTab, setSelectedWeek, setSelectedYear } = pulseNavigationSlice.actions;
export default pulseNavigationSlice.reducer;